import React from 'react';
import Button from './Button';

interface MemberNotFoundProps {
  onClick?: () => void;
}

const MemberNotFound: React.FC<MemberNotFoundProps> = ({ onClick }) => {
  return (
    <div className="ceas-bg-white ceas-min-h-full ceas-px-4 ceas-py-16 sm:ceas-px-6 sm:ceas-py-24 md:ceas-grid md:ceas-place-items-center lg:ceas-px-8 ceas-text-center">
      <div className="ceas-max-w-max ceas-mx-auto">
        <main className="sm:ceas-flex">
          <p className="ceas-text-4xl ceas-font-extrabold ceas-text-red-600 sm:ceas-text-5xl">
            :'(
          </p>
          <div className="sm:ceas-ml-6">
            <div className="sm:ceas-border-l sm:ceas-border-gray-200 sm:ceas-pl-6">
              <h2 className="ceas-text-xl ceas-font-extrabold ceas-text-gray-900 ceas-tracking-tight sm:ceas-text-4xl">
                Member not found
              </h2>
              <p className="ceas-mt-1 ceas-text-base ceas-text-gray-500">
                Please check the QR code and try again.
              </p>
              {onClick && <Button theme="primary" onClick={onClick}>Re-Scan</Button>}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default MemberNotFound;
